/** Strip TipTap HTML to plain text for URL / OpenGraph extraction. */
export const plainTextForUrls = (text) =>
  text.startsWith('<')
    ? text.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim()
    : text;
